import React, { useState, useEffect } from "react";
import { config } from "../config/config";

const NotaForm = ({ onSubmit, initialData, resetForm }) => {
    // Estado para los datos del formulario
    const [formData, setFormData] = useState({
        alumno_id: "",
        materia_id: "",
        ano: "",
        periodo: "",
        nota: "",
    });

    // Estados para las listas de alumnos y materias
    const [alumnos, setAlumnos] = useState([]);
    const [materias, setMaterias] = useState([]);

    // Cargar la lista de alumnos y materias al montar el componente
    useEffect(() => {
        // Obtener la lista de alumnos
        fetch(`${config.apiUrl}/alumnos/asignaciones`)
            .then((res) => res.json())
            .then(setAlumnos)
            .catch(console.error);

        // Obtener la lista de materias
        fetch(`${config.apiUrl}/materias`)
            .then((res) => res.json())
            .then(setMaterias)
            .catch(console.error);
    }, []);

    // Actualizar el formulario cuando cambien initialData o resetForm
    useEffect(() => {
        if (initialData) {
            setFormData(initialData);
        } else if (resetForm) {
            setFormData({
                alumno_id: "",
                materia_id: "",
                ano: "",
                periodo: "",
                nota: "",
            });
        }
    }, [initialData, resetForm]);

    // Manejar cambios en los campos del formulario
    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData({ ...formData, [name]: value });
    };

    // Manejar el envío del formulario
    const handleSubmit = (e) => {
        e.preventDefault();
        onSubmit(formData);
    };

    return (
        <div className="container mt-5">
            <h2 className="mb-4">Formulario de Notas</h2>
            <form onSubmit={handleSubmit} className="p-3 border rounded bg-light">
                <div className="row">
                    <div className="col-md-6 mb-3">
                        <label htmlFor="alumno_id" className="form-label">Alumno:</label>
                        <select
                            id="alumno_id"
                            name="alumno_id"
                            className="form-control"
                            value={formData.alumno_id}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Seleccione un alumno</option>
                            {alumnos.map((alumno) => (
                                <option key={alumno.alumno_id} value={alumno.alumno_id}>
                                    {alumno.alumno_nombre}
                                </option>
                            ))}
                        </select>
                    </div>
                    <div className="col-md-6 mb-3">
                        <label htmlFor="materia_id" className="form-label">Materia:</label>
                        <select
                            id="materia_id"
                            name="materia_id"
                            className="form-control"
                            value={formData.materia_id}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Seleccione una materia</option>
                            {materias.map((materia) => (
                                <option key={materia.materia_id} value={materia.materia_id}>
                                    {materia.nombre_materia}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-4 mb-3">
                        <label htmlFor="ano" className="form-label">Año:</label>
                        <input
                            type="number"
                            id="ano"
                            name="ano"
                            className="form-control"
                            value={formData.ano}
                            onChange={handleChange}
                            required
                            min="2000"
                            max="2100"
                        />
                    </div>
                    <div className="col-md-4 mb-3">
                        <label htmlFor="periodo" className="form-label">Período:</label>
                        <select
                            id="periodo"
                            name="periodo"
                            className="form-control"
                            value={formData.periodo}
                            onChange={handleChange}
                            required
                        >
                            <option value="">Seleccione un período</option>
                            <option value="1">1</option>
                            <option value="2">2</option>
                            <option value="3">3</option>
                            <option value="4">4</option>
                        </select>
                    </div>
                    <div className="col-md-4 mb-3">
                        <label htmlFor="nota" className="form-label">Nota:</label>
                        <input
                            type="number"
                            id="nota"
                            name="nota"
                            className="form-control"
                            value={formData.nota}
                            onChange={handleChange}
                            required
                            step="0.01"
                            min="0"
                            max="100"
                        />
                    </div>
                </div>
                <div className="text-center">
                    <button type="submit" className="btn btn-primary">Guardar</button>
                </div>
            </form>
        </div>);
};

export default NotaForm;